<template>
  <el-card class="point" shadow="hover" :body-style="bodyStyle">
    <el-row>
      <el-col :span="6">
        <Device :point="point" />
      </el-col>
      <el-col :span="6" v-if="point.connectedDevice && point.connectedDevice.type != 'DUCKV1'">
        <Profile :point="point" v-if="point.device && point.device.macAddress" />
      </el-col>
      <el-col :span="6" v-if=" point.connectedDevice && point.connectedDevice.type == 'DUCKV1'">
        <el-form label-position="top" v-model="point.channelGroup">
          <el-form-item :label='$t("duck.sensor")' prop="channelGroup">
            <el-select multiple v-model="selectedChannelGroups" @change="updateDuckChannelGroup">
              <el-option v-for="item in selectedDuckSensors" :key="item.value" :label="item.label"
                :disabled="item.disabled" :value="item.value" />
            </el-select>
            <!-- trash icon -->
          </el-form-item>

        </el-form>
      </el-col>
      <el-col  :span="6" v-if="point.connectedDevice && point.connectedDevice.type != 'DUCKV1'">
        <Periodic :point="point" />
      </el-col>
      <el-col :span="5" v-if="point.connectedDevice && point.connectedDevice.type != 'DUCKV1'">
        <Trigger :device="point.connectedDevice.macAddress" />
      </el-col>

    </el-row>
    <el-divider v-if="checkPermission('createMeasurement')" class="divide-iot" content-position="left">{{
        $t("common.connectivity")
    }}</el-divider><br />
    <IoT v-if="checkPermission('createMeasurement')" :point="point" />
  </el-card>
</template>

<script>
import Device from "./Point_Device";
import Profile from "./Point_Profile";
import Periodic from "./Point_Periodic";
import Trigger from "./Device_Trigger";
import IoT from "./Point_IoT";
import treeHelper from "../util/treeHelper";
import { mapState, mapActions } from "vuex";

export default {
  name: "Point",
  props: ["point"],
  components: { Device, Profile, Periodic, Trigger, IoT },
  created() { },
  data() {

    return {
      duck: "",
      samplingRate: "",
      selectedChannelGroups: "",
      bodyStyle: {
        padding: "5px",
      },
    };
  },
  async created() {
    await this.getDucks();
    if (this.point.device) {
      this.duck = this.ducks.find(x => x.macAddress == this.point.device.macAddress);
      this.selectedChannelGroups = this.point.device.channelGroups || []; 
      console.log(this.point.device)
    }
  },
  computed: {
    ...mapState("duck", ["ducks"]),
    ...mapState("tree",["flatTree"]),
    selectedDuckSensors() {
      if (this.point.device) {
        if (this.duck) {
          let selectedSensors = this.duck.config.sensors.filter(x => this.selectedChannelGroups.includes(x.groupCode)).map(x=>x.name);
          // alert(selectedSensors)
          let x = this.duck.config.sensors.map(x => {
            return {
              value: x.groupCode,
              label: x.displayName,
              disabled: (x.point && x.point != this.point._id) || (selectedSensors.includes(x.name))
            };
          });
          return x;
        }
      }
      return [];

    },
    path() {
      return treeHelper.pointIdToPath(this.flatTree,this.point_id);
    },

  },
  watch: {
    "point": function () {
      if (this.point.device) {
        this.duck = this.ducks.find(x => x.macAddress == this.point.device.macAddress);
        console.log("watching point")
        this.selectedChannelGroups = this.point.device.channelGroups || [];
      }
    }
  },
  methods: {
   
    async updateDuckChannelGroup() {
      if (this.point.device) {
        let payload = { id: this.point._id, channelGroups: this.selectedChannelGroups };
        await this.updateChannelGroups(payload);

        await this.getDucks();
      }
    }
    ,
    ...mapActions("point", [
      "updateChannelGroups","getPoints"
    ]),
    ...mapActions("duck", [
      "getDucks",

    ]),
  }
};
</script>
<style>
.info {
  padding: 10px;
  color: #232323;
  font-style: italic;
  font-size: 10px;
}

.point .el-card__header {
  padding: 10px;
}
</style>
<style  scoped>
.divide-iot {
  margin-bottom: 0px !important;
}

.device .header:hover .edit,
.el-card__header:hover .edit {
  opacity: 1;
}

.edit {
  opacity: 0;
}

.device {
  padding: 10px;
}

.device .body li {
  list-style-type: none;
  margin-bottom: 10px;
}

.device .header {
  font-size: 14px;
  padding-bottom: 5px;
  border-bottom: 1px solid rgb(226, 226, 226);
}

.path {
  margin-left: 5px;
  line-height: -20px;
  font-size: 12px;
  color: gray;
}

.name {
  font-size: 20px;
  font-weight: bold;
}

.point {
  margin-bottom: 10px;
}
</style>